import { ApolloProvider } from '@apollo/client/react';
import { BrowserRouter } from 'react-router-dom';

import CommonReports from '../features/reports/common-reports/CommonReports';
import { GeneratedReports } from '../features/reports/generated-reports-table/GeneratedReports';
import { Notifications } from '../features/reports/reports-notifications/Notifications';
import { client } from '../graphql/client';
import { CurrentEmployerContext } from '../utils/currentEmployer';

type Props = {
  employerId: string;
};

export const ReportsApp: React.FC<Props> = props => {
  const { employerId } = props;
  return (
    <BrowserRouter>
      <ApolloProvider client={client}>
        <CurrentEmployerContext.Provider value={employerId}>
          <Notifications />
          <CommonReports />
          <GeneratedReports />
        </CurrentEmployerContext.Provider>
      </ApolloProvider>
    </BrowserRouter>
  );
};
